module.exports = __webpack_public_path__ + "img/silver4.84a8d9c9.png";